import { toast } from 'sonner';
import { api } from './api';

const KEYS = { theme: 'bond_portal_theme', pdf_cover: 'bond_pdf_cover', pdf_graph: 'bond_pdf_graph', graph_style: 'bond_graph_style' };

const write = (k, v) => localStorage.setItem(KEYS[k], k === 'pdf_graph' ? (v ? '1' : '0') : v);

export const savePref = (k, v) => {
  write(k, v);
  return api.put('/auth/preferences', { [k]: v }).catch(() => toast.error('Preferenza non salvata sul profilo'));
};

// Profile wins; on first use the browser's current choices are copied to the profile.
export const syncPrefs = (user) => {
  const p = user?.preferences || {};
  if (Object.keys(p).length) {
    Object.entries(p).forEach(([k, v]) => KEYS[k] && v !== null && v !== undefined && write(k, v));
    return;
  }
  const local = {};
  if (localStorage.getItem(KEYS.pdf_cover)) local.pdf_cover = localStorage.getItem(KEYS.pdf_cover);
  if (localStorage.getItem(KEYS.pdf_graph)) local.pdf_graph = localStorage.getItem(KEYS.pdf_graph) === '1';
  if (Object.keys(local).length) api.put('/auth/preferences', local).catch(() => {});
};
